import {bugsnagClientNotify} from "../../../../bark-core";
import {_t} from '@bark/bark-core';

export default async function () {
    try {
        /**
         * Window.Bark global
         * @type Window.Bark
         */
        var Bark = window.Bark = window.Bark || {};

        /**
         * Window.Bark.feedback global
         * @type Window.Bark.feedback
         */
        var feedback = Bark.feedback = Bark.feedback || {};

        /**
         * Window.Bark.feedback.questions global
         * @type Window.Bark.feedback.questions
         */
        var qs = feedback.questions = feedback.questions || {};

        /**
         * Questions with options
         * @type Array
         */
        var questionsWithOptions = ['checkbox', 'select'];

        /**
         * A list of the deleted options
         * @type Array
         */
        var deletedOptions = [];

        /**
         * A JSON representation of the form at entry
         * @type String
         */
        var formAtEntry = null;

        /**
         * Submit lock
         * @type Boolean
         */
        var submitting = false;

        /**
         * Set the form at entry. This allows us to detect whether the user has actually made any changes
         */
        function setFormAtEntry() {
            var type = $('#feedback_submit').data('type');
            var form;

            switch (type) {
                case 'add':
                    form = getAddFormData();
                    break;

                case 'remove':
                    form = getRemoveFormData();
                    break;
            }

            formAtEntry = JSON.stringify(form);
        }

        /**
         * Validate the add/update question form
         * @param {object} data An object of data to validate
         */
        function validateAddForm(data) {
            if (!data.title) {
                $('#question-title').addClass('is-invalid');
                $('.title-error.invalid-feedback').text(_t("seller_feedback-questions:form.inputs.question.error.empty"));
                return;
            }

            if (!data.type) {
                $('#question-type').addClass('is-invalid');
                $('.type-error').text(_t("seller_feedback-questions:form.inputs.type-of-answer.error.empty")).addClass('form-error');
                return;
            }

            return true;
        }

        /**
         * Validate the remove question form
         * @param {object} data An object of data to validate
         */
        function validateRemoveForm(data) {
            if (!data.id) {
                $('.question-error').text(_t("seller_feedback-questions:form.inputs.question.error.no-option-selected")).addClass('form-error');
                return;
            }

            if (!data.feedback) {
                $('#remove-reason').addClass('form-error');
                $('.message-error').text(_t("seller_feedback-questions:form.inputs.reason.error.empty")).addClass('form-error');
                return;
            }

            if (data.feedback.length < 30) {
                $('#remove-reason').addClass('form-error');
                $('.message-error').text(_t("seller_feedback-questions:form.inputs.reason.error.min-characters")).addClass('form-error');
                return;
            }

            return true;
        }

        /**
         * Get the data for the add form
         * @returns {object}
         */
        function getAddFormData() {
            var modifyData = $('.modify-question-container').data() || {};
            var data = {
                id: modifyData.id || null,
                title: $('#question-title').val().trim(),
                type: ($('#question-type').val() || '').trim(),
                options: [],
                deleted_options: deletedOptions,
                user_name: null,
                user_email: null,
                feedback_title: Bark.sprintf('%s question: question id %s, category %s', modifyData.action, modifyData.id || 'n/a', modifyData.categoryId),
                feedback: null,
                action: modifyData.action,
                category_id: modifyData.categoryId
            };

            if (Bark.in_array(data.type, questionsWithOptions)) {
                $('.option-row:visible .opt-label').each(function () {
                    var t = $(this);
                    var label = t.val().trim();
                    var id = t.closest('.option-row').data('id') || null;

                    if (label && t.data('changed')) {
                        data.options.push({
                            label: label,
                            id: id
                        });
                    }
                });
            }

            return data;
        }

        /**
         * Get the data for the remove data
         * @returns {object}
         */
        function getRemoveFormData() {
            var removeData = $('.delete-question-container').data() || {};
            var removeId = $('.question-options input:checked').val();
            var data = {
                id: removeId,
                type: ($('#question-type').val() || '').trim(),
                user_name: null,
                user_email: null,
                feedback_title: Bark.sprintf('remove question: question id %s, category %s', removeId || 'n/a', removeData.categoryId),
                feedback: $('#remove-reason').val().trim(),
                action: 'remove',
                category_id: removeData.categoryId
            };

            return data;
        }

        /**
         * Determine whether changes have been made on the form
         * @returns {Boolean}
         */
        function changesMade() {
            var type = $('#feedback_submit').data('type');
            var form;
            var encoded;

            switch (type) {
                case 'add':
                    form = getAddFormData();
                    break;

                case 'remove':
                    form = getRemoveFormData();
                    break;
            }

            encoded = JSON.stringify(form);

            return encoded !== formAtEntry;
        }

        /**
         * Save the add/update form
         */
        qs.saveAddForm = function () {
            var data = getAddFormData();

            $('.form-error').removeClass('form-error');

            if (submitting || !validateAddForm(data)) {
                return;
            }

            if (!changesMade()) {
                alert(_t("seller_feedback-questions:form.error.no-changes"));
                return;
            }

            submitting = true;

            $.post('/api/event-log/', {
                event_category: 'feedback-question',
                event_name: 'click',
                event_id: 'save-' + data.action + '-question'
            });

            Bark.showLoading(null, null, _t("seller_feedback-questions:form.saving-suggestion"));

            // Use Bark.json as it has CSRF built in
            Bark.json({
                url: '/feedback/save/questions/',
                data: {payload: JSON.stringify(data)}
            }).done(function (e) {
                if (e.result === 'OK') {
                    document.location = e.redirect;
                    return;
                }

                alert(e.result);
                submitting = false;
                Bark.hideLoading();
            }).fail(function () {
                submitting = false;
                alert(_t("seller_feedback-questions:form.error.cannot-save"));
                Bark.hideLoading();
            });
        };

        /**
         * Save the remove question form
         */
        qs.saveRemoveForm = function () {
            var data = getRemoveFormData();

            $('.error-msg-field').removeClass('form-error');

            if (submitting || !validateRemoveForm(data)) {
                return;
            }

            if (!changesMade()) {
                alert(_t("seller_feedback-questions:form.error.no-changes"));
                return;
            }

            $.post('/api/event-log/', {
                event_category: 'feedback-question',
                event_name: 'click',
                event_id: 'save-remove-question'
            });

            submitting = true;
            Bark.showLoading(null, null, _t("seller_feedback-questions:form.saving-suggestion"));

            // Use Bark.json as it has CSRF built in
            Bark.json({
                url: '/feedback/save/questions/',
                data: {payload: JSON.stringify(data)}
            }).done(function (e) {
                if (e.result === 'OK') {
                    document.location = e.redirect;
                    return;
                }

                alert(e.result);
                submitting = false;
                Bark.hideLoading();
            }).fail(function () {
                alert(_t("seller_feedback-questions:form.error.cannot-save"));
                submitting = false;
                Bark.hideLoading();
            });
        };

        /**
         * Bindings
         */
        qs.initBinding = function () {

            $('#question-type').off('change.toggle').on('change.toggle', function () {
                var showoptions = Bark.in_array($(this).val(), questionsWithOptions);
                $('.options-sect')[showoptions ? 'removeClass' : 'addClass']('d-none');
            });

            $('.remove-question-opt').off('click.remove').on('click.remove', function () {
                var t = $(this);
                var parent = t.closest('.option-row');
                var rem = {
                    'id': parent.data('id'),
                    'label': $('.opt-label', parent).val() || null
                };

                if (rem.label && confirm(_t("seller_feedback-questions:form.removal-confirm"))) {
                    deletedOptions.push(rem);
                    $('#feedback_submit').removeAttr('disabled');
                    window.setTimeout(function () {
                        $.post('/api/event-log/', {
                            event_category: 'feedback-question',
                            event_name: 'click',
                            event_id: 'remove-question-option-confirmed'
                        });
                    }, 20);
                    parent.remove();
                }

                if (!rem.id && !rem.label) {
                    parent.remove();
                }
            });

            $('.add-option').off('click.addrow').on('click.addrow', function () {
                var clone = $('.new-row-clone').children().clone();
                clone.insertBefore('.add-option-container');
                $('.opt-label', clone).focus();
                $('#feedback_submit').removeAttr('disabled');
                qs.initBinding();
            });

            $('#feedback_submit').off('click.submit').on('click.submit', function () {
                var type = $(this).data('type');

                switch (type) {
                    case 'add':
                        qs.saveAddForm();
                        break;

                    case 'remove':
                        qs.saveRemoveForm();
                        break;
                }
            });

            $('.question-suggest-parent :input').off('change.enable').on('change.enable', function () {
                $('#feedback_submit').removeAttr('disabled');
            });

            $('.opt-label').off('change.update').on('change.update', function () {
                $(this).data({changed: true});
            });

            $('.js-tr').off('click.tr').on('click.tr', function () {
                var name = $(this).data('evt-name');
                var eid = $(this).data('evt-id');

                if (!name || !eid || $(this).is(':disabled')) {
                    return false;
                }

                $.post('/api/event-log/', {
                    event_category: 'feedback-question',
                    event_name: name,
                    event_id: eid
                });
            });

        };

        $(function () {
            qs.initBinding();
            setFormAtEntry();
        });

    } catch (e) {
        bugsnagClientNotify('Error loading seller feedback questions', e)
        console.log(e);
    }
}
